module.exports = __webpack_public_path__ + "static/media/exit.e844eba5.svg";